import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileCategoriesOpen, setMobileCategoriesOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="text-lg font-semibold text-foreground-900 font-heading whitespace-nowrap"
          >
            Vigorbuy Spreadsheet
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-7">
            <Link to="/" className="text-sm text-accent-600 font-medium hover:text-accent-700 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-home-4-line mr-1"></i> Home
            </Link>
            <Link to="/#guides" className="text-sm text-foreground-700 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-book-open-line mr-1"></i> Shopping Guide
            </Link>
            <a href="/#categories" className="text-sm text-foreground-700 hover:text-accent-600 transition-colors whitespace-nowrap">Categories</a>
            <a href="/#what-is" className="text-sm text-foreground-700 hover:text-accent-600 transition-colors whitespace-nowrap">About</a>
            <a href="/#safety" className="text-sm text-foreground-700 hover:text-accent-600 transition-colors whitespace-nowrap">Safety</a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="bg-primary-500 text-background-50 px-5 py-2 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Visit Main Site
            </a>
          </div>

          {/* Mobile Hamburger */}
          <button
            className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
          >
            <i className={`text-xl text-foreground-800 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div className="md:hidden pb-5 flex flex-col gap-1 border-t border-background-200/60 pt-4">
            <Link
              to="/"
              className="flex items-center gap-3 text-sm text-accent-600 font-medium py-2.5 px-2 rounded-md hover:bg-accent-50 transition-colors cursor-pointer"
              onClick={() => setMobileOpen(false)}
            >
              <i className="ri-home-4-line text-base w-5 h-5 flex items-center justify-center"></i> Home
            </Link>

            <Link
              to="/#guides"
              className="flex items-center gap-3 text-sm text-foreground-700 py-2.5 px-2 rounded-md hover:bg-accent-50 transition-colors cursor-pointer"
              onClick={() => setMobileOpen(false)}
            >
              <i className="ri-book-open-line text-base w-5 h-5 flex items-center justify-center"></i> Shopping Guide
            </Link>

            {/* Mobile Categories Accordion */}
            <div>
              <button
                className="flex items-center justify-between w-full text-sm text-foreground-700 py-2.5 px-2 rounded-md hover:bg-accent-50 transition-colors cursor-pointer"
                onClick={() => setMobileCategoriesOpen(!mobileCategoriesOpen)}
              >
                <span className="flex items-center gap-3">
                  <i className="ri-grid-line text-base w-5 h-5 flex items-center justify-center"></i> Categories
                </span>
                <i className={`text-sm transition-transform ${mobileCategoriesOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}></i>
              </button>

              {mobileCategoriesOpen && (
                <div className="ml-5 mt-1 mb-2 grid grid-cols-2 gap-1">
                  {categories.map((cat) => (
                    <a
                      key={cat.slug}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-2 text-xs text-foreground-600 py-1.5 px-2 rounded hover:bg-accent-50 hover:text-accent-600 transition-colors cursor-pointer"
                      onClick={() => setMobileOpen(false)}
                    >
                      <i className={`${cat.icon} text-xs w-4 h-4 flex items-center justify-center`}></i>
                      {cat.name}
                    </a>
                  ))}
                </div>
              )}
            </div>

            <a
              href="/#what-is"
              className="flex items-center gap-3 text-sm text-foreground-700 py-2.5 px-2 rounded-md hover:bg-accent-50 transition-colors cursor-pointer"
              onClick={() => setMobileOpen(false)}
            >
              <i className="ri-information-line text-base w-5 h-5 flex items-center justify-center"></i> About
            </a>

            <a
              href="/#safety"
              className="flex items-center gap-3 text-sm text-foreground-700 py-2.5 px-2 rounded-md hover:bg-accent-50 transition-colors cursor-pointer"
              onClick={() => setMobileOpen(false)}
            >
              <i className="ri-shield-check-line text-base w-5 h-5 flex items-center justify-center"></i> Safety
            </a>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center justify-center gap-2 bg-primary-500 text-background-50 px-5 py-3 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer mt-2 whitespace-nowrap"
            >
              Visit Main Site <i className="ri-arrow-right-up-line text-sm"></i>
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}